import * as React from "react";
import "./Icon.css";
const SvgCogIcon = ({ width, height, ...props }) => {
  React.useEffect(() => {
    console.debug("CogIcon rendered");
  }, []);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 48 48"
      width={width || undefined}
      height={height ? height : "auto"}
      fill="currentColor"
      {...props}
      className={`svg-icon spin-icon-target ${props.className || ""}`}
      style={{
        transformOrigin: "center",
        ...props.style,
        ...(width ? { width: width } : {}),
        ...(height ? { height: height } : {}),
      }}
    >
      <path
        d="M48 22.84a2.19 2.19 0 0 0-2-2.17l-6.61-.5a16 16 0 0 0-1.8-4.33l4.32-5a2.17 2.17 0 0 0-.11-3l-1.65-1.63a2.17 2.17 0 0 0-2.95-.11l-5 4.32a16 16 0 0 0-4.33-1.8L27.33 2a2.19 2.19 0 0 0-2.17-2h-2.32a2.19 2.19 0 0 0-2.17 2l-.5 6.61a16 16 0 0 0-4.33 1.8l-5-4.32a2.17 2.17 0 0 0-3 .11L6.21 7.85a2.17 2.17 0 0 
0-.11 3l4.32 5a16 16 0 0 0-1.8 4.33L2 20.67a2.19 2.19 0 0 0-2 2.17v2.32a2.19 2.19 0 0 0 2 2.17l6.61.5a16 16 0 0 0 1.8 4.33l-4.32 5a2.17 2.17 0 0 0 .11 2.95l1.64 1.64a2.17 2.17 0 0 0 3 .11l5-4.32a16 16 0 0 0 4.33 1.8l.5 6.61a2.19 2.19 0 0 0 2.17 2h2.32a2.19 2.19 0 0 0 2.17-2l.5-6.61a16 16 0 0 0 4.33-1.8l5 4.32a2.17 2.17 0 0 0 2.95-.11l1.64-1.64a2.17 2.17 0 0 0 .11-2.95l-4.32-5a16 16 0 0 0 1.8-4.33l6.61-.5a2.19 2.19 0 0 0 2-2.17ZM33.65 24A9.65 9.65 0 1 1 24 14.2a9.73 9.73 0 0 1 9.65 9.8"
      />
    </svg>
  );
};
export default SvgCogIcon;
